<div class="shadow exam-header d-flex flex-column flex-md-row justify-content-between align-content-center align-items-center p-3" id="exam-header">
    <div></div>
  <div class="w-75 d-flex flex-column flex-md-row justify-content-center align-items-center">
    <div class="progress-bar-exam w-75 rounded d-flex">
      <div class="progress rounded bg-bluesky" style="width:{{(step/7)*100}}%">
      </div>
    </div>
    <span class="text-primary bolder mt-3 mt-md-0 ml-3">{{ step }} / 7</span>
  </div>
    <div class="bg-lighter m-2 py-2 px-4 rounded shadow d-flex justify-content-between align-items-center bolder text-primary timer">
      <i class="fa-solid fa-stopwatch mr-2"></i>
      {{ timeLeft }}
    </div>
</div>
<div class="bg-bluesky h-100 game-exam">

  <app-first-listening [idLevel]="idLevel" (eventEmitter)="next($event)" *ngIf="!ending && examResult && examResult.status === 'FIRST_LISTENING'">
  </app-first-listening>

  <app-second-listening [idLevel]="idLevel" (eventEmitter)="next($event)" *ngIf="!ending && examResult && examResult.status === 'SECOND_LISTENING'">
  </app-second-listening>

  <app-third-listening [idLevel]="idLevel" (eventEmitter)="next($event)" *ngIf="!ending && examResult && examResult.status === 'THIRD_LISTENING'">
  </app-third-listening>

  <app-fourth-listening [idLevel]="idLevel" (eventEmitter)="next($event)" *ngIf="!ending && examResult && examResult.status === 'FOURTH_LISTENING'">
  </app-fourth-listening>

  <app-first-reading [idLevel]="idLevel" (eventEmitter)="next($event)" *ngIf="!ending && examResult && examResult.status === 'FIRST_READING'">
  </app-first-reading>

  <app-second-reading [idLevel]="idLevel" (eventEmitter)="next($event)" *ngIf="!ending && examResult && examResult.status === 'SECOND_READING'">
  </app-second-reading>

  <app-third-reading [idLevel]="idLevel" (eventEmitter)="next($event)" *ngIf="!ending && examResult && examResult.status === 'THIRD_READING'">
  </app-third-reading>

  <div class="container py-5" *ngIf="ending">
    <div class="instructions d-flex bg-white shadow-card light-rounded align-items-center justify-content-center text-center flex-column w-100 mx-auto">
      <div class="w-75">
        <img src="/assets/images/mascotte/revision.svg" alt="Revision" class="img"/>
        <div translate class="nunito-bold text-lg mt-3 mb-4">Votre teste est terminé, nous enregistrons vos réponses</div>
        <ngb-progressbar [value]="seconds" [max]="maxSeconds" type="primary"></ngb-progressbar>
      </div>
    </div>
  </div>
</div>
